import FreeFallScreenSF_4D from './Free-Fall-screen-SF-4D.png';
import FreeFallScreenSF_3D from './Free-Fall-screen-SF-3D.png';
import FreeFallScreenSF_4D2 from './Free-Fall-screen-SF-4D_2.png';
import FreeFallScreenSF_3D2 from './Free-Fall-screen-SF-3D_2.png';
import type { UnitInfoFreeFallScreenSFInterface } from 'store/units/types';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';

export const getImageFreeFallScreenSF = (decks: number) => {
  if (decks === 4) {
    return FreeFallScreenSF_4D;
  } else {
    return FreeFallScreenSF_3D;
  }
};

export const getImageFreeFallScreenSF2 = (decks: number) => {
  if (decks === 4) {
    return FreeFallScreenSF_4D2;
  } else {
    return FreeFallScreenSF_3D2;
  }
};

export const nbrOfDecks = ['3', '4'];
export const models = {
  3: ['SF1443', 'SF1843'],
  4: ['SF1844'],
};

export const screeningElements = [
  { name: 'Wire, square holes', value: 'WIRE_SQUARE' },
  { name: 'Wire, rect. width in flow dir.', value: 'WIRE_RECT_TR' },
  { name: 'Wire, rect. length in flow dir.', value: 'WIRE_RECT_LG ' },
];

export const materials = [
  { name: 'Normal crushed stone', value: 'NORMAL_CRUSHED_STONE' },
  { name: 'Mix, 50% nat. / 50% crushed', value: 'MIXED_NATURAL_CRUSHED' },
  { name: 'Cubical crushed (VSI/HSI)', value: 'CUBICAL_CRUSHED' },
  { name: 'Uncrushed sand and gravel', value: 'UNCRUSHED_SAND_AND_GRAVEL' },
];

export const getDefaultData = (): UnitInfoFreeFallScreenSFInterface => {
  return {
    modelName: models[3][0],
    nbrOfDecks: 3,
    deckList: {
      0: {
        separationSize: 25,
        screeningMediaId: screeningElements[0],
        display: { separationSize: true, screeningElement: false },
      },
      1: {
        separationSize: 16,
        screeningMediaId: screeningElements[0],
        display: { separationSize: true, screeningElement: false },
      },
      2: {
        separationSize: 8,
        screeningMediaId: screeningElements[0],
        display: { separationSize: true, screeningElement: false },
      },
      3: {
        separationSize: 4,
        screeningMediaId: screeningElements[0],
        display: { separationSize: true, screeningElement: false },
      },
    },
    deckOneRelieving: false,
    materialType: materials[0],
    moisture: 0,
    newMoisture: false,
    parallelUnits: 1,
    display: {
      displayNotes: {
        noteOne: false,
        noteTwo: false,
        noteThree: false,
        noteFour: false,
        noteFive: false,
      },
      displayUnitName: true,
      displayModelName: true,
      displayLoad: true,
      displayNumberOfDecks: false,
    },
  };
};

export const getHorsePower = (kW: number) => {
  return (kW * 1.3596216173).toFixed(2);
};

export class FreeFallScreenSFConfig extends BaseUnitConfig {
  static getDefaultData(): UnitInfoFreeFallScreenSFInterface {
    return {
      modelName: models[3][0],
      nbrOfDecks: 3,
      deckList: {
        0: {
          separationSize: 25,
          screeningMediaId: screeningElements[0],
          display: { separationSize: true, screeningElement: false },
        },
        1: {
          separationSize: 16,
          screeningMediaId: screeningElements[0],
          display: { separationSize: true, screeningElement: false },
        },
        2: {
          separationSize: 8,
          screeningMediaId: screeningElements[0],
          display: { separationSize: true, screeningElement: false },
        },
        3: {
          separationSize: 4,
          screeningMediaId: screeningElements[0],
          display: { separationSize: true, screeningElement: false },
        },
      },
      deckOneRelieving: false,
      materialType: materials[0],
      ...BaseUnitConfig.getBaseDefaults(),
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayLoad: true,
        displayNumberOfDecks: false,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 5;
  }
}

export const freeFallScreenSFConfig = new FreeFallScreenSFConfig();
